'use strict';
var ApplicationLoading = require('../components/ApplicationLoading.jsx').default;
var ClientApplication = require('../components/ClientApplication.jsx');
var InvestorType = require('../components/InvestorType.jsx');
var ClientType = require('../components/ClientType.jsx').default;
var NotFound = require('../components/NotFound.jsx');

function getHomeForExistingApplication() {
    return ApplicationLoading;
}

function getHomeForNewApplication(bootstrap) {
    var userContext = bootstrap.userContext;
    if (!bootstrap || !userContext) {
        return NotFound;
    }

    if (userContext.isInvestor) {
        if (userContext.isExisting) {
            return ClientApplication.default;
        }
        return InvestorType;
    }

    if (userContext.isAdviser) {
        if (bootstrap.clientOin) {
            return ClientApplication.default;
        }
        return ClientType;
    }

    return NotFound;
}

module.exports = {
    getHome: function (bootstrap) {
        if (bootstrap.isError) {
            return null;
        }

        return bootstrap.applicationId ? getHomeForExistingApplication() : getHomeForNewApplication(bootstrap);
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./core/HomeResolver.js